import { SalaryType } from '@/lib/generated/graphql-types'
import { ShowRowHintRow } from '../constants'
import { useSalaryTableStore } from '../salary-table-context'
import { SalaryVisibility } from './constants'

const ROW_HINT_SPLIT_INDEX = 3

export function isShowRowHintRow(
  salary: SalaryType | ShowRowHintRow,
): salary is ShowRowHintRow {
  return 'showRowHint' in salary
}

export function useShowRowHint({
  salaries,
  showTableRowHint,
  blurTotalCompensation,
  salaryVisibility,
}: {
  salaries: SalaryType[]
  showTableRowHint: boolean | undefined
  blurTotalCompensation: boolean | undefined
  salaryVisibility: string | undefined | null
}) {
  // We need the cookie and useState check for
  // the SSR initial page load, and if the user interacts
  // with the row client side
  const hasInteractedWithRow = useSalaryTableStore(
    (state) => state.hasInteractedWithRow,
  )
  const showRowHint =
    showTableRowHint &&
    !hasInteractedWithRow &&
    !(
      blurTotalCompensation ||
      salaryVisibility === SalaryVisibility.Restricted ||
      salaryVisibility === SalaryVisibility.None
    )
  const salariesWithRowHint = showRowHint
    ? [
        ...salaries.slice(0, ROW_HINT_SPLIT_INDEX),
        {
          showRowHint: true,
        } as ShowRowHintRow,
        ...salaries.slice(ROW_HINT_SPLIT_INDEX),
      ]
    : salaries
  return {
    showRowHint,
    salariesWithRowHint,
  }
}
